document.addEventListener("DOMContentLoaded", (event) => {
  gsap.registerPlugin(ScrollTrigger);

  let listItem = gsap.utils.toArray("images-with-text-scrolling .media");
  gsap.set(
    ".shopify-section--dynamic-reviews .images-scrolling-mobile__item .image-with-text__image-wrapper .media",
    {
      opacity: 0,
      scale: 1,
    }
  );

  const animation = gsap.to(
    ".shopify-section--dynamic-reviews .images-scrolling-mobile__item .image-with-text__image-wrapper .media",
    {
      opacity: 1,
      scale: 1,
      duration: 1,
      stagger: 1,
    }
  );
  ScrollTrigger.create({
    trigger: "images-with-text-scrolling",
    start: "top top",
    end: "bottom bottom",
    // pin: true, // Optional pin functionality
    pin: ".shopify-section--dynamic-reviews .image-with-text__image-wrapper",
    animation: animation,
    scrub: true,
    markers: true,
    onToggle: (self) => console.log('toggled, isActive:', self.isActive),
    onUpdate: (self) => {
        console.log(
            'progress:',
            self.progress.toFixed(3),
            'direction:',
            self.direction,
            'velocity',
            self.getVelocity()
        );
    }
  });
});
